import JobInfiniteScrollContainer from "../../../components/job/other/JobInfiniteScroll";

const JobInfiniteScroll = () => {
  return <JobInfiniteScrollContainer />;
};

export default JobInfiniteScroll;
